import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.blue,
        secondary: colors.shades.white,
        accent: colors.blue.lighten1,
        accent2: colors.grey,
      },
      dark: {
        primary: colors.blue,
        secondary: colors.shades.black,
        accent: colors.blue.lighten1,
      },
    },
  },
});
